/**
 * O juízo da custódia curta do Conferir envio (F-E144.F4-01): sai da última conferência, da
 * situação conferida de cada original e das ocorrências em aberto, e não é fixo. O alcance
 * temporal ("desde o recebimento") é outra linha e não muda com o juízo.
 */
import type { ReciboDaCustodiaData } from '@/lib/abertura_do_caso';

export type EstadoDaCustodia =
  | { tipo: 'sem_conferencia' }
  | { tipo: 'divergencia'; abertas: number }
  | { tipo: 'compativel' };

export function estadoDaCustodia(recibo: ReciboDaCustodiaData): EstadoDaCustodia {
  const abertas = (recibo.ocorrencias ?? []).filter((o) => o.resolucao === null).length;
  const ultima = recibo.ultima_conferencia ?? null;
  const originalComProblema = recibo.originais.some((o) => {
    const situacao = o.conferencia?.situacao;
    return situacao === 'diverge' || situacao === 'ausente';
  });
  const conferenciaComProblema = ultima !== null && ultima.divergem + ultima.ausentes > 0;
  if (abertas > 0 || originalComProblema || conferenciaComProblema) {
    return { tipo: 'divergencia', abertas };
  }
  return ultima === null ? { tipo: 'sem_conferencia' } : { tipo: 'compativel' };
}
